import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { tap } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  const authService = inject(AuthService);
  const router = inject(Router);

  const token = authService.token;
  let $response;

  if (token) {
    const clonedRequest = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`)
    });
    $response = next(clonedRequest);
  } else {
    $response = next(req);
  }
  return $response
    .pipe(tap({
      error: error => {
        if (error instanceof HttpErrorResponse && error.status === 403) {
          authService.logout();
          router.navigate(['/login']);
        }
      }
    }))
};
